import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { AlertCircle, XCircle, HelpCircle } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
export function PainPoints() {
  const pains = [{
    icon: <XCircle className="w-8 h-8 text-red-400" data-id="element-217" />,
    title: 'Publicas pero no vendes',
    desc: 'Creas contenido constantemente, subes reels, stories, pero tu cuenta bancaria sigue igual.'
  }, {
    icon: <HelpCircle className="w-8 h-8 text-amber-400" data-id="element-218" />,
    title: 'Tienes ideas, cero ingresos',
    desc: 'Sabes que podrías enseñar algo, pero no tienes ni idea de cómo empaquetarlo y cobrar por ello.'
  }, {
    icon: <AlertCircle className="w-8 h-8 text-orange-400" data-id="element-219" />,
    title: 'Ves a otros facturar',
    desc: 'Ves gente con menos talento que tú vendiendo productos digitales y no entiendes cómo empezaron.'
  }];
  return <section className="py-24 px-4 bg-[#050510] relative overflow-hidden" data-id="element-220">
      {/* Background Image with 15% opacity */}
      <div className="absolute inset-0 z-0" data-id="element-221">
        <img src="https://cdn.magicpatterns.com/uploads/7CWi7Yy7BizvjqVr5UKXuR/IMG_1922_2.jpg" alt="Background" className="w-full h-full object-cover opacity-15" data-id="element-222" />
        {/* Gradient overlay to blend edges with the sections above and below */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#050510] via-transparent to-[#050510]" data-id="element-223" />
      </div>

      <div className="container mx-auto max-w-6xl relative z-10" data-id="element-224">
        <ScrollReveal className="text-center mb-16" data-id="element-225">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 drop-shadow-lg" data-id="element-226">
            ¿Te suena familiar?
          </h2>
          <p className="text-xl text-gray-300 drop-shadow-md" data-id="element-227">
            La mayoría de creadores están atrapados aquí.
          </p>
        </ScrollReveal>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-228">
          {pains.map((pain, index) => <ScrollReveal key={index} delay={index * 0.2} direction="up" className="h-full" data-id="element-229">
              <div className="glass-card p-8 rounded-2xl h-full border-t-4 border-t-red-500/50 hover:border-t-red-500 transition-all duration-300 group bg-[#0c0c20]/60 backdrop-blur-xl" data-id="element-230">
                <div className="mb-6 p-4 bg-white/5 rounded-full w-fit group-hover:scale-110 transition-transform duration-300" data-id="element-231">
                  {pain.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-white" data-id="element-232">
                  {pain.title}
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-233">{pain.desc}</p>
              </div>
            </ScrollReveal>)}
        </div>

        <SectionCTA headline="¿Cansado de publicar sin resultados?" buttonText="QUIERO EMPEZAR A MONETIZAR" data-id="element-234" />
      </div>
    </section>;
}